import React from 'react';
import DateBox from 'devextreme-react/date-box';
import { SelectBox } from 'devextreme-react/select-box';
import { getRequestParams, formatDate } from '../../helpers/globalfunctions';
import { LoadPanel } from 'devextreme-react/load-panel';
import Modal from 'react-modal'; //npm install --save react-modal
import Swal from 'sweetalert2';
import { SendEmailComponent } from '../Shared/SendEmailComponent'
const position = { of: '#historydiv' };

export class VehicleLoanReportComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSubmited: false,
            isEmailSubmitted: false,
            isOpenModal: false,
            loadPanelVisible: false,

            chkFranchiseeSelection: "1",
            dropdownFranchisee: [],
            franchiseeId: 0,

            chkVehicleSelection: "1",
            dropdownVehicle: [],
            vehicleId: 0,

            chkPaymentPeriodSelection: "1",
            startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
            endDate: new Date(),

            chkReportTypeSelection: "1",

            errors: {
                franchiseeId: '',
                vehicleId: '',
            }
        }
        this.getFranchisee = this.getFranchisee.bind(this);
        this.handleFranchiseeChange = this.handleFranchiseeChange.bind(this);
        this.handleFranchiseeSelectionChange = this.handleFranchiseeSelectionChange.bind(this);

        this.getVehicle = this.getVehicle.bind(this);
        this.handleVehicleChange = this.handleVehicleChange.bind(this);
        this.handleVehicleSelectionChange = this.handleVehicleSelectionChange.bind(this);

        this.handlePayPeriodSelectionChange = this.handlePayPeriodSelectionChange.bind(this);
        this.handleFromDateChanged = this.handleFromDateChanged.bind(this);
        this.handleToDateChanged = this.handleToDateChanged.bind(this);

        this.handleReportTypeSelectionChange = this.handleReportTypeSelectionChange.bind(this);

        this.downloadAccountPaymentTypeSummaryAsPdf = this.downloadAccountPaymentTypeSummaryAsPdf.bind(this);

        this.handleSearchAccountPaySummaryReportSubmit = this.handleSearchAccountPaySummaryReportSubmit.bind(this);
        this.handleClearSearch = this.handleClearSearch.bind(this);
    }

    showModal = async () => {
        try {
            this.setState({ isOpenModal: true });
        } catch (ex) {
            console.log(ex);
        }
    }
    handleOnAfterOpenModal = async () => {
        try {
            this.setState({ loadPanelVisible: true });
            await this.getFranchisee();
            await this.getVehicle();
        } catch (ex) {
            console.log(ex);
        }
        this.setState({ loadPanelVisible: false });
    }
    handleOnCloseModal = async () => {

        this.setState({ isOpenModal: false });
        await this.handleClearSearch();
    }

    async getFranchisee() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('franchisee-api/0/0', requestParams);
            const data = await response.json();
            this.setState({
                dropdownFranchisee: data.franchisees,
            });

        } catch (e) {
            console.log(e);
        }
    }

    handleFranchiseeChange = (selectedOption) => {
        try {
            let errors = this.state.errors;
            errors.franchiseeId = '';
            let franchiseeId = 0;
            if (selectedOption !== null && selectedOption.selectedItem !== null) {
                franchiseeId = selectedOption.selectedItem.id === null ? 0 : selectedOption.selectedItem.id;
            }
            this.setState({ franchiseeId: franchiseeId, errors: errors });
        } catch (ex) {
            console.log(ex);
        }
    }

    handleFranchiseeSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        
        this.setState({
            chkFranchiseeSelection: value,
            franchiseeId: 0,
        });

        let errors = this.state.errors;
        errors.franchiseeId = "";
        this.setState({ errors: errors });
    }

    async getVehicle() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('vehicle-api/dropdown/0/0', requestParams);
            const data = await response.json();
            this.setState({
                dropdownVehicle: data.vehiclesDropdown,
            });

        } catch (e) {
            console.log(e);
        }
    }

    handleVehicleChange = (selectedOption) => {
        try {
            let errors = this.state.errors;
            errors.vehicleId = '';
            let vehicleId = 0;
            if (selectedOption !== null && selectedOption.selectedItem !== null) {
                vehicleId = selectedOption.selectedItem.id === null ? 0 : selectedOption.selectedItem.id;
            }
            this.setState({ vehicleId: vehicleId, errors: errors });
        } catch (ex) {
            console.log(ex);
        }
    }

    handleVehicleSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        
        this.setState({
            chkVehicleSelection: value,
            vehicleId: 0
        });

        let errors = this.state.errors;
        errors.vehicleId = "";
        this.setState({ errors: errors });
    }

    handlePayPeriodSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;        
        this.setState({ chkPaymentPeriodSelection: value });
    }

    handleFromDateChanged(event) {
        let fromDateValue = formatDate(event.value, "MM/dd/yyyy");
        this.setState({ startDate: fromDateValue })
    }
    handleToDateChanged(event) {
        let toDateValue = formatDate(event.value, "MM/dd/yyyy");
        this.setState({ endDate: toDateValue })
    }

    handleReportTypeSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        
        this.setState({ chkReportTypeSelection: value });
    }

    handleSearchAccountPaySummaryReportSubmit(e) {
        e.preventDefault();
        if (this.handleValidation()) {
            this.downloadAccountPaymentTypeSummaryAsPdf();
        }
    }
    handleClearSearch() {
        this.setState({
            isSubmited: false,
            isEmailSubmitted: false,
            isOpenModal: false,
            loadPanelVisible: false,

            chkFranchiseeSelection: "1",
            franchiseeId: 0,

            chkVehicleSelection: "1",
            vehicleId: 0,

            chkPaymentPeriodSelection: "1",
            startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
            endDate: new Date(),

            chkReportTypeSelection: "1",

            errors: {
                franchiseeId: '',
                vehicleId: '',
            }
        });
    }

    handleValidation() {
        let errors = this.state.errors;
        let formIsValid = true;
        errors.vehicleId = "";
        errors.franchiseeId = "";

        if (this.state.chkFranchiseeSelection === "2" && this.state.franchiseeId === 0) {
            formIsValid = false;
            errors.franchiseeId = "Please select franchisee.";
        }

        if (this.state.chkVehicleSelection === "2" && this.state.vehicleId === 0) {
            formIsValid = false;
            errors.vehicleId = "Please select vehicle.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }
    async downloadAccountPaymentTypeSummaryAsPdf() {
        try {
            this.setState({
                isSubmited: true,
            });
            var RptHead = "";
            var request = {};
            request.LocationId = Number(sessionStorage.getItem("session_locationId"));
            if (this.state.chkFranchiseeSelection === "1") {
                request.FranchiseeId = parseInt(0);
                RptHead = RptHead + ", for all Vehicles";
            } else {
                request.FranchiseeId = parseInt(this.state.franchiseeId);
                let puZone = this.state.dropdownFranchisee.find(opt => opt.id === this.state.franchiseeId);
                RptHead = RptHead + ", for Franchisee " + puZone.name;
            }

            if (this.state.chkVehicleSelection === "1") {
                request.VehicleId = parseInt(0);
                RptHead = RptHead + ", for all Vehicles";
            } else {
                request.VehicleId = parseInt(this.state.vehicleId);
                let puZone = this.state.vehiclesList.find(opt => opt.id === this.state.vehicleId);
                RptHead = RptHead + ", for Vehicle " + puZone.name;
            }

            if (this.state.chkPaymentPeriodSelection === "1") {
                request.StartDate = null;
                request.EndDate = null;
                RptHead = RptHead + "For all date ";
            } else {
                request.StartDate = formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:00";
                request.EndDate = formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59";
                RptHead = RptHead + "For date range " + formatDate(this.state.startDate, "MM/dd/yyyy") + " to " + formatDate(this.state.endDate, "MM/dd/yyyy");
            }
            request.Header = RptHead;
            request.ReportType = parseInt(this.state.chkReportTypeSelection);
            request.MethodName = "GetVehicleLoanReports";
            request.fileFormat = 'pdf';

            const requestParams = getRequestParams('POST', request);
            const response = await fetch('crystal-report-api', requestParams);
            const dataResponse = await response.json();
            this.setState({
                isSubmited: false,
            });

            let a = document.createElement('a');
            a.href = dataResponse.reportBase64String;
            if (this.state.chkReportTypeSelection === "1") {
                a.download = 'VehicleLoanOutstandingReport.pdf';
            } else if (this.state.chkReportTypeSelection === "2") {
                a.download = 'LoanSummaryWithPaySchedule.pdf';
            } else {
                a.download = 'VehicleDetailedTransaction.pdf';
            }
            a.click();
        } catch (e) {
            this.setState({
                isSubmited: false,
            });
            console.log(e)
        }
    }
    handleOnSendEmail = async (event) => {
        event.preventDefault();
        try {
            if (this.handleValidation()) {
                this.setState({ isEmailSubmitted: true });
                var RptHead = "";
                var request = {};
                request.LocationId = Number(sessionStorage.getItem("session_locationId"));
                if (this.state.chkFranchiseeSelection === "1") {
                    request.FranchiseeId = parseInt(0);
                    RptHead = RptHead + ", for all Vehicles";
                } else {
                    request.FranchiseeId = parseInt(this.state.franchiseeId);
                    let puZone = this.state.dropdownFranchisee.find(opt => opt.id === this.state.franchiseeId);
                    RptHead = RptHead + ", for Franchisee " + puZone.name;
                }

                if (this.state.chkVehicleSelection === "1") {
                    request.VehicleId = parseInt(0);
                    RptHead = RptHead + ", for all Vehicles";
                } else {
                    request.VehicleId = parseInt(this.state.vehicleId);
                    let puZone = this.state.vehiclesList.find(opt => opt.id === this.state.vehicleId);
                    RptHead = RptHead + ", for Vehicle " + puZone.name;
                }

                if (this.state.chkPaymentPeriodSelection === "1") {
                    request.StartDate = null;
                    request.EndDate = null;
                    RptHead = RptHead + "For all date ";
                } else {
                    request.StartDate = formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:00";
                    request.EndDate = formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59";
                    RptHead = RptHead + "For date range " + formatDate(this.state.startDate, "MM/dd/yyyy") + " to " + formatDate(this.state.endDate, "MM/dd/yyyy");
                }
                request.Header = RptHead;
                request.ReportType = parseInt(this.state.chkReportTypeSelection);
                request.MethodName = "GetVehicleLoanReports";
                request.fileFormat = 'pdf';

                const requestParams = getRequestParams('POST', request);
                const response = await fetch('crystal-report-api', requestParams);
                const dataResponse = await response.json();
                let reportName = '';
                if (this.state.chkReportTypeSelection === "1") {
                    reportName = 'VehicleLoanOutstandingReport.pdf';
                } else if (this.state.chkReportTypeSelection === "2") {
                    reportName = 'LoanSummaryWithPaySchedule.pdf';
                } else {
                    reportName = 'VehicleDetailedTransaction.pdf';
                }
                this.setState({ isEmailSubmitted: false });
                let fileData = dataResponse.reportBase64String;
                if (fileData !== null && fileData !== '') {
                    let emailSubject = 'Vehicle Loan Report';
                    let attachments = [];
                    let file = {};
                    file.fileData = fileData;
                    file.fileName = reportName
                    file.fileExtension = '.pdf';
                    attachments.push(file);
                    this.refs.sendEmailComponent.showModal('', '', emailSubject, '', attachments);
                }
                else {
                    Swal.fire({
                        allowOutsideClick: false,
                        showCloseButton: true,
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong! Unable to process the email request.',
                    })
                }
            }
        } catch (ex) {
            console.log(ex);
        }
        this.setState({ isEmailSubmitted: false });
    }
    render() {
        return (
            <div>
                <Modal ariaHideApp={false}
                    isOpen={this.state.isOpenModal}
                    style={{ content: { width: '60%' } }}
                    className={"react-modal"}
                    onAfterOpen={this.handleOnAfterOpenModal}
                    onRequestClose={this.handleOnCloseModal}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal">
                    <form method="post" onSubmit={this.handleSearchAccountPaySummaryReportSubmit}
                        style={(this.state.isSubmited || this.state.isEmailSubmitted) ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                        <div className="modal-header">
                            <h6 className="modal-title">Vehicle Loan Report</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleOnCloseModal}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="allFranchisee" value="1" checked={this.state.chkFranchiseeSelection === "1"} onChange={this.handleFranchiseeSelectionChange} />
                                            <label className="form-check-label">All Franchisee</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="singleFranchisee" value="2" checked={this.state.chkFranchiseeSelection === "2"} onChange={this.handleFranchiseeSelectionChange} />
                                            <label className="form-check-label">Single Franchisee</label>
                                        </span>
                                        <SelectBox
                                            dataSource={this.state.dropdownFranchisee}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select Franchisee"
                                            name="ddfranchisee"
                                            defaultValue={0}
                                            value={this.state.franchiseeId}
                                            displayExpr='name'
                                            valueExpr='id'
                                            onSelectionChanged={this.handleFranchiseeChange}
                                            showClearButton={true}
                                            disabled={(this.state.chkFranchiseeSelection === '1')}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["franchiseeId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["franchiseeId"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="allVehicles" value="1" checked={this.state.chkVehicleSelection === "1"} onChange={this.handleVehicleSelectionChange} />
                                            <label className="form-check-label">All Vehicles</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="singleVehicle" value="2" checked={this.state.chkVehicleSelection === "2"} onChange={this.handleVehicleSelectionChange} />
                                            <label className="form-check-label">Single Vehicle</label>
                                        </span>
                                        <SelectBox
                                            dataSource={this.state.dropdownVehicle}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select Vehicle"
                                            name="ddvehicle"
                                            defaultValue={0}
                                            value={this.state.vehicleId}
                                            displayExpr='name'
                                            valueExpr='id'
                                            onSelectionChanged={this.handleVehicleChange}
                                            showClearButton={true}
                                            disabled={(this.state.chkVehicleSelection === '1')}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["vehicleId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["vehicleId"]}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <label htmlFor="">&nbsp;</label>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdInRange" value="1" checked={this.state.chkPaymentPeriodSelection === "1"} onChange={this.handlePayPeriodSelectionChange} />
                                            <label className="form-check-label">All Period</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdInRange" value="2" checked={this.state.chkPaymentPeriodSelection === "2"} onChange={this.handlePayPeriodSelectionChange} />
                                            <label className="form-check-label">Date Range</label>
                                        </span>
                                        <DateBox type="date"
                                            className="form-control form-control-sm"
                                            name="fromDate"
                                            placeholder="mm/dd/yyyy"
                                            useMaskBehavior={true}
                                            defaultValue={this.state.startDate}
                                            value={this.state.startDate}
                                            onValueChanged={this.handleFromDateChanged}
                                            width="100%"
                                            disabled={this.state.chkPaymentPeriodSelection === "1"}
                                            acceptCustomValue={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <label>To Date</label>
                                        <DateBox type="date"
                                            className="form-control form-control-sm"
                                            name="toDate"
                                            placeholder="mm/dd/yyyy"
                                            useMaskBehavior={true}
                                            defaultValue={this.state.endDate}
                                            value={this.state.endDate}
                                            onValueChanged={this.handleToDateChanged}
                                            width="100%"
                                            disabled={this.state.chkPaymentPeriodSelection === "1"}
                                            acceptCustomValue={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <label htmlFor="">Report Type</label><br />
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdVehicleLoan" value="1" checked={this.state.chkReportTypeSelection === "1"} onChange={this.handleReportTypeSelectionChange} />
                                            <label className="form-check-label">Vehicle Loan Outstanding Report</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdLoanSummary" value="2" checked={this.state.chkReportTypeSelection === "2"} onChange={this.handleReportTypeSelectionChange} />
                                            <label className="form-check-label">Loan Summary With Pay Schedule</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdVehicleDetails" value="3" checked={this.state.chkReportTypeSelection === "3"} onChange={this.handleReportTypeSelectionChange} />
                                            <label className="form-check-label">Vehicle Detail Transaction</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success btn-sm" onClick={this.handleOnSendEmail} >
                                {this.state.isEmailSubmitted && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isEmailSubmitted && <span title="Send Email"><i className="fas fa-envelope"></i> Send Email</span>}
                            </button>
                            <button type="button" className="btn btn-success btn-sm" title="Download" onClick={this.handleSearchAccountPaySummaryReportSubmit} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                                {this.state.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isSubmited && <span title="Search"><i className="fas fa-file-pdf"></i> Download</span>}
                            </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" title="Clear"
                                onClick={this.handleClearSearch}>
                                <i className="fas fa-eraser"></i> Clear
                                </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" title="Close"
                                onClick={this.handleOnCloseModal}>
                                <i className="fas fa-times"></i> Close
                                </button>
                        </div>
                    </form>
                </Modal>
                <SendEmailComponent ref="sendEmailComponent" />
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={position}
                    visible={this.state.loadPanelVisible}
                    showIndicator={true}
                    shading={false}
                    showPane={true}
                    closeOnOutsideClick={false}
                />
            </div >
        )
    }
}